/**
 * DocumentIcon/index.js
 * desc: document icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const DocumentIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="document icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.document.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 16 20" xmlns="http://www.w3.org/2000/svg"><path d="M.01 2C.01.9.9 0 2 0h8l6 6v12c0 1.1-.9 2-2 2H1.99C.89 20 0 19.1 0 18L.01 2zM9 1.5V7h5.5L9 1.5z" /></svg>
    </IconButton>
);


export default DocumentIcon;
